import { useEffect, useState } from "react";

export function useNavbar() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  function toggleNavbar() {
    setIsCollapsed(prev => !prev);
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1530) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    handleResize(); 
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isCollapsed,
    toggleNavbar,
  };
}
